module.exports = __webpack_public_path__ + "static/img/zhenling.71af4c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zhenling.png
// module id = jG+X
// module chunks = 24